import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import Grid from "modules/common/components/Grid";
import { useMemo } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Filter, Pagination } from "../../common";
import type { AirportRankingTableProps } from "./AirportRankingTable.d";

const { Box, Flex, Heading } = Chakra;

const AirportRankingTable = ({ columns, rows, heading }: AirportRankingTableProps) => {
  const memoColumns = useMemo(() => columns, [columns]);
  const memoRows = useMemo(() => rows, [rows]);
  const translations = useTranslations();

  const {
    getTableProps,
    getTableBodyProps,
    page,
    nextPage,
    previousPage,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    headerGroups,
    gotoPage,
    state: { globalFilter, pageIndex },
    setGlobalFilter,
  } = useTable(
    {
      columns: memoColumns,
      data: memoRows,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Box bg="greyscale.300" py={14}>
      <Grid mb={0}>
        <Box gridColumn={{ base: "span 1", md: "span 12" }}>
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "flex-start", md: "center" }}
          >
            <Heading variant="h3" as="h3">
              {translations(heading)}
            </Heading>
            <Filter
              filter={globalFilter}
              setFilter={setGlobalFilter}
              placeholder={translations("search_for_airport")}
            />
          </Flex>
          <Table
            rows={page}
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            getTableBodyProps={getTableBodyProps}
            prepareRow={prepareRow}
          />
          {pageOptions.length ? (
            <Pagination
              previousPage={previousPage}
              canPreviousPage={canPreviousPage}
              pages={pageOptions.length}
              nextPage={nextPage}
              currentPage={pageIndex + 1}
              canNextPage={canNextPage}
              gotoPage={gotoPage}
            />
          ) : (
            <Box textAlign="center">-</Box>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default AirportRankingTable;
